export default "__VITE_ASSET__fc55209d__"